module.exports = {
  primary: '#6737b8',
  secondary: '#FFC107',
  accent: '#40C4FF',
};
